import type { IconName } from '../models/types';
import { renderIcon } from './icons';

/**
 * İkon seçici — dokunmatik bir ızgara.
 *
 * Seçilen ikon, formun içindeki gizli bir alana yazılır; böylece
 * form gönderilirken diğer alanlarla aynı yerden okunur ve çağıran
 * tarafın ayrıca durum tutması gerekmez.
 *
 * Hem alışkanlık hem oda formları bunu kullanıyor.
 */

/** Alışkanlıklara atanabilecek ikonlar. */
export const HABIT_ICON_CHOICES: IconName[] = [
  'water',
  'moon',
  'walk',
  'smoke',
  'book',
  'apple',
  'broom',
  'dumbbell',
  'laptop',
  'social',
  'toothbrush',
  'cube',
  'home',
  'checklist',
  'trophy',
  'flame',
];

/** Odalara atanabilecek ikonlar — ev bölümlerini çağrıştıranlar önde. */
export const ROOM_ICON_CHOICES: IconName[] = [
  'home',
  'moon',
  'water',
  'checklist',
  'broom',
  'cube',
  'book',
  'laptop',
  'apple',
  'toothbrush',
  'dumbbell',
  'social',
];

/**
 * Izgarayı ve ona bağlı gizli alanı üretir.
 * `fieldName`, formda okunacak alanın adıdır (genellikle "icon").
 */
export function renderIconPicker(
  selected: IconName,
  choices: IconName[],
  fieldName = 'icon',
): string {
  const options = choices
    .map(
      (icon) => `
        <button type="button"
                class="icon-choice${icon === selected ? ' icon-choice--on' : ''}"
                data-icon="${icon}" aria-pressed="${icon === selected}"
                aria-label="${icon} ikonu">
          ${renderIcon(icon, { size: 20 })}
        </button>
      `,
    )
    .join('');

  return `
    <div class="icon-picker" role="group" aria-label="İkon seç">${options}</div>
    <input type="hidden" name="${fieldName}" value="${selected}" />
  `;
}

/**
 * Izgaradaki dokunmaları gizli alana bağlar.
 * `renderIconPicker` çıktısı DOM'a eklendikten sonra çağrılmalı.
 */
export function attachIconPicker(container: HTMLElement, fieldName = 'icon'): void {
  const field = container.querySelector<HTMLInputElement>(`input[name="${fieldName}"]`);
  if (!field) return;

  for (const button of container.querySelectorAll<HTMLElement>('[data-icon]')) {
    button.addEventListener('click', () => {
      field.value = button.dataset['icon'] ?? field.value;

      // Seçim tek olmalı: önce hepsini kapat, sonra dokunulanı aç.
      for (const other of container.querySelectorAll('.icon-choice')) {
        other.classList.remove('icon-choice--on');
        other.setAttribute('aria-pressed', 'false');
      }
      button.classList.add('icon-choice--on');
      button.setAttribute('aria-pressed', 'true');
    });
  }
}
